(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-wholesale-apparel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  const field = event.target;
  if (!field.matches('.wp-apparel-form select[name="contact[Apparel interest]"]')) return;
  const quantity = field.form.querySelector('input[name="contact[Estimated quantity]"]');
  const minimum = field.selectedOptions[0]?.dataset.minimum || '20';
  if (quantity) quantity.min = minimum;
});

  } catch(e) { console.error(e); }
})();
})();
